export const filtersKeys = [
  'includedSectorIds',
  'includedIndustryIds',
  'includedSubindustryIds',
  'includedIssuerIds',
  'includedParentIds',
  'includedRegionIds',
  'includedCountryIds',
  'includedDealIds',
  'dates',
];
